import Link from "next/link";
const styles = new Proxy({"Tag":"Tag-5ead2"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import { type Tag } from "@/themes/ci/blog/types";

const Tag = ({ tag }: { tag: Tag }) => {
  return (
    <Link href={`/blog/1?tags=${tag.slug}`} className={styles.Tag}>
      {tag.name}
    </Link>
  );
};

export default Tag;
